<div class="app-content">
  <div class="router-content">
    <div class="image-bg">
      <img src="https://uploads-ssl.webflow.com/609d7b25dbc93b8fa508beb3/61000c92db957294a2a8d53a_jfl-piscina.jpg"
        alt="bg-jfl">
      <div class="image-overlay"></div>
    </div>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
